// extracted by mini-css-extract-plugin
export default {"group":"OutlinedLabel_group__TtUgk","input":"OutlinedLabel_input__Q2bCA","label":"OutlinedLabel_label__dAtj5"};